import { render, staticRenderFns } from "./SupplierGallery.vue?vue&type=template&id=3177cc39&scoped=true&"
import script from "./SupplierGallery.vue?vue&type=script&lang=js&"
export * from "./SupplierGallery.vue?vue&type=script&lang=js&"
import style0 from "./SupplierGallery.vue?vue&type=style&index=0&id=3177cc39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3177cc39",
  null
  
)

export default component.exports